import * as React from "react";

export default class MapArea extends React.Component {
    path() {
        const area = this.props.area;
        const zoomLevel = this.props.zoomLevel;
        const points = area.coords;

        if (!points.length || !zoomLevel) {
            return '';
        }

        let first = points[0], last = points[points.length - 1];

        let path = 'M' + (first[0] * zoomLevel) + ',' + (first[1] * zoomLevel);

        points.forEach(point => {
            path += 'L' + (point[0] * zoomLevel) + ',' + (point[1] * zoomLevel);
        });

        path += 'M' + first[0] * zoomLevel + ',' + first[1] * zoomLevel + 'L' + last[0] * zoomLevel + ',' + last[1] * zoomLevel;

        return path + 'Z';
    }

    render() {
        let d = this.path();


        let className = '';

        if (this.props.area.object) {
            className += `status-${this.props.area.object.status_id}`;
        }

        if (this.props.active) {
            className += ' active';
        }

        if (this.props.hidden) {
            className += ' hidden';
        }
        //const statusClass = this.props.area.object ? `status-${this.props.area.object.status_id}` : '';

        return (
            <path d={d} className={className} strokeWidth={0}
                  onClick={() => this.props.onClick(this.props.area)}
                  onMouseEnter={() => !this.props.hidden && this.props.onMouseEnter(this.props.area)}
                  onMouseLeave={() => this.props.onMouseLeave(this.props.area)}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MapArea.jsx